import { render, staticRenderFns } from "./BarOrder.vue?vue&type=template&id=785e0044&scoped=true"
import script from "./BarOrder.vue?vue&type=script&lang=js"
export * from "./BarOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e0044",
  null
  
)

export default component.exports